module.exports = __webpack_public_path__ + "static/paleosite_morphing-b4f00b73ac07885e1068ceab577efafb.png";